/**
 * @file 提供可更新URL的Query部分的能力
 * @author zhanglili
 */

import {Component} from 'react';
import {withRouter} from 'react-router';
import updateQuery from 'update-query';
import {wrapDisplayName} from 'recompose';

export default ComponentIn => {
    const ComponentOut = class extends Component {

        static displayName = wrapDisplayName(ComponentIn, 'updateableSearch');

        updateURLQuery = queryPatch => {
            const {history, location: {pathname, search, hash}} = this.props;
            const url = pathname + search + hash;
            const newURL = updateQuery(url, queryPatch);
            history.push(newURL);
        }

        render() {
            return <ComponentIn updateURLQuery={this.updateURLQuery} {...this.props} />;
        }
    };

    return withRouter(ComponentOut);
};
